import endpoint from "../../config/endpoints";

export const OrderApprovalAuthorityJson = {
    showSaveNextBtn: true,
    formPath: "/order-approval-authority-form",
    apiBaseURL: endpoint.orderApprovalAuthority,
    changeExcel: endpoint.orderApprovalAuthority,
    screenTitle: "Order Approval Authority",
    showAddButton: true,
    showPdfDownload: false,
    pdfFileName: "Order Approval Authority",
    showExcelDownload: true,
    excelFileName: "Order Approval Authority",
    tableColumnsToFilter: [
        {
            columnDisplayName: "Sales Team Name",
            columnKeyName: "salesTeamName",
            isChecked: true,
        },
        {
            columnDisplayName: "Authority Name",
            columnKeyName: "authorityName",
            isChecked: true,
        },
        {
            columnDisplayName: "Stock Holder Name",
            columnKeyName: "stockHolderName",
            isChecked: true,
        },
        {
            columnDisplayName: "Status",
            columnKeyName: "isActive",
            isChecked: true,
        },
    ],
    fieldMeta: [
        {
            label: "Sales Team",
            controlType: "autocomplete",
            placeHolder: "Select Sales Team",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            masterName: "salesTeamDetail",
            dataKey: "salesTeamId",
            getListId: "salesTeamId",
            isRootLevelKey: true,
            isMandatory: true,
        },
        {
            label: "Authority Sales Team",
            controlType: "autocomplete",
            placeHolder: "Select Authority Sales Team",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            masterName: "authoritySalesTeamDetail",
            dataKey: "authorityId",
            getListFrom: "salesTeamId",
            isRootLevelKey: true,
            isMandatory: true,
        },
        {
            label: "Stock Holder",
            controlType: "autocomplete",
            placeHolder: "Select Stock Holder",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            masterName: "stockHolderDetail",
            dataKey: "distributorId",
            isRootLevelKey: true,
            isMandatory: false,
        },
    ],
    fieldMetaWithoutStockHolder: [
        {
            label: "Sales Team",
            controlType: "autocomplete",
            placeHolder: "Select Sales Team",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            masterName: "salesTeamDetail",
            dataKey: "salesTeamId",
            getListId: "salesTeamId",
            isRootLevelKey: true,
            isMandatory: true,
        },
        {
            label: "Authority Sales Team",
            controlType: "autocomplete",
            placeHolder: "Select Authority Sales Team",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            masterName: "authoritySalesTeamDetail",
            dataKey: "authorityId",
            getListFrom: "salesTeamId",
            isRootLevelKey: true,
            isMandatory: true,
        },
    ],
};
